exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preloader2[data-v-69de0faa]{position:fixed;top:0;bottom:0;left:0;right:0;z-index:99999}.spinner[data-v-69de0faa]{margin:auto;width:30px;height:30px;position:relative;top:1%;text-align:center;animation:sk-rotate-data-v-69de0faa .5s infinite linear}.dot1[data-v-69de0faa],.dot2[data-v-69de0faa]{width:60%;height:60%;display:inline-block;position:absolute;top:0;background-color:#ccc;border-radius:100%;animation:sk-bounce-data-v-69de0faa .5s infinite ease-in-out}.dot2[data-v-69de0faa]{top:auto;bottom:0;animation-delay:-.25s}@keyframes sk-rotate-data-v-69de0faa{to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}@keyframes sk-bounce-data-v-69de0faa{0%,to{transform:scale(0);-webkit-transform:scale(0)}50%{transform:scale(1);-webkit-transform:scale(1)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69de0faa","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/bounce.vue
// module id = 72
// module chunks = 23